import React from "react";

const BotAvatar = ({ avatarImg, size = "35px" }) => {
  return (
    <div
      className=""
      style={{
        minWidth: size,
        height: size,
        borderRadius: "50%",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#D2CFC7",
        border: "1px solid #red",
      }}
    >
      <img
        src={avatarImg}
        alt=""
        style={{
          width: "90%",
          height: "90%",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default BotAvatar;
